import RequestAbstract from "../abstract";

export default class MerchantLocations extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/merchant-locations";
    }
}
